import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const popularItems = [
  {
    title: 'popular.review.title',
    desc: 'popular.review.desc',
    to: '/usfans-review',
    image:
      'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20magnifying%20glass%20resting%20over%20a%20folded%20streetwear%20t%20shirt%20with%20five%20small%20gold%20star%20ratings%20floating%20nearby%20on%20a%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20review%20concept%20photography%2C%20high%20detail%2C%20clean%20minimal%20composition&width=800&height=500&seq=usfans-pop-01&orientation=landscape',
  },
  {
    title: 'popular.shipping.title',
    desc: 'popular.shipping.desc',
    to: '/usfans-shipping-cost',
    image:
      'https://readdy.ai/api/search-image?query=A%20stack%20of%20cardboard%20shipping%20boxes%20with%20brown%20packing%20tape%20on%20a%20light%20grey%20floor%20near%20a%20soft%20window%2C%20gentle%20daylight%2C%20logistics%20delivery%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20airy%20composition&width=800&height=500&seq=usfans-pop-02&orientation=landscape',
  },
  {
    title: 'popular.coupon.title',
    desc: 'popular.coupon.desc',
    to: '/usfans-coupon',
    image:
      'https://readdy.ai/api/search-image?query=A%20collection%20of%20gift%20cards%20discount%20tags%20and%20a%20small%20wrapped%20present%20with%20a%20red%20ribbon%20arranged%20on%20a%20warm%20sand%20background%2C%20soft%20natural%20lighting%2C%20savings%20and%20promotion%20concept%20photography%2C%20editorial%20flat%20lay%2C%20high%20detail%2C%20clean%20balanced%20composition&width=800&height=500&seq=usfans-pop-03&orientation=landscape',
  },
  {
    title: 'popular.discount.title',
    desc: 'popular.discount.desc',
    to: '/usfans-coupon',
    image:
      'https://readdy.ai/api/search-image?query=A%20bright%20percentage%20off%20symbol%20made%20of%20paper%20tags%20and%20a%20small%20shopping%20cart%20with%20folded%20clothes%20on%20a%20soft%20mint%20background%2C%20soft%20daylight%2C%20discount%20promotion%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20minimal%20composition&width=800&height=500&seq=usfans-pop-04&orientation=landscape',
  },
  {
    title: 'popular.warehouse.title',
    desc: 'popular.warehouse.desc',
    to: '/usfans-warehouse',
    image:
      'https://readdy.ai/api/search-image?query=Tall%20industrial%20shelving%20units%20filled%20with%20neatly%20organized%20cardboard%20boxes%20inside%20a%20bright%20modern%20warehouse%2C%20soft%20overhead%20lighting%2C%20logistics%20and%20storage%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20wide%20composition&width=800&height=500&seq=usfans-pop-05&orientation=landscape',
  },
  {
    title: 'popular.legit.title',
    desc: 'popular.legit.desc',
    to: '/usfans-legit',
    image:
      'https://readdy.ai/api/search-image?query=A%20large%20green%20checkmark%20shield%20icon%20floating%20above%20a%20folded%20stack%20of%20clothing%20items%20on%20a%20soft%20light%20mint%20background%2C%20soft%20studio%20lighting%2C%20trust%20and%20verification%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20minimal%20composition&width=800&height=500&seq=usfans-pop-06&orientation=landscape',
  },
];

export default function Popular() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{t('popular.title')}</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">{t('popular.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {popularItems.map((item) => (
            <Link
              key={item.title}
              to={item.to}
              className="group rounded-lg border border-background-200 bg-background-50 hover:border-secondary-300 transition-colors overflow-hidden cursor-pointer"
            >
              <div className="h-40 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={t(item.title)}
                  title={`${t(item.title)} USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-700">
                  {t(item.title)}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t(item.desc)}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/usfans-spreadsheet"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 cursor-pointer"
          >
            {t('articles.readMore')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}